export const SET_CUSTOMER_DATA_FILLED_FROM_LOGIN = 'SET_CUSTOMER_DATA_FILLED_FROM_LOGIN';

export type SetCustomerDataFilledFromLoginActionType = {
	type: typeof SET_CUSTOMER_DATA_FILLED_FROM_LOGIN;
	payload: boolean;
};

export const setCustomerDataFilledFromLogin = (
	payload: boolean
): SetCustomerDataFilledFromLoginActionType => ({
	type: SET_CUSTOMER_DATA_FILLED_FROM_LOGIN,
	payload,
});
